import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PcmpPendingReportPrintPage } from '@/features/pcmp/pages/PcmpPendingReportPrintPage';
import { pcmpPendingReportSearchSchema } from '@/features/pcmp/types/pcmpReports.types';

export const Route = createFileRoute('/_print/pcmp/reports/pending/print')({
  validateSearch: pcmpPendingReportSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="PCMP Pending Report">
      <PcmpPendingReportPrintPage />
    </ErrorBoundary>
  ),
});
